import React from 'react';
import BadgeGenerator from './components/BadgeGenerator';
import './App.css';

function App() {
  return (
    <div className="App">
      <BadgeGenerator />
    </div>
  );
}

export default App;